<template>
  <MasterdataTableContainer
    :loading="$apollo.loading"
    :headers="headers"
    :table-data="tableData"
    :sort-by="sortBy"
    :actions="actions"
    :refetch="refetch"
    :components="components"
  />
</template>

<script>
import gql from 'graphql-tag'
import MasterdataTableContainer from '@/modules/masterdata/components/MasterdataTableContainer'
import MasterdataForecastsCreateModal from './MasterdataForecastsCreateModal'
import MasterdataForecastsEditModal from './MasterdataForecastsEditModal'
import MasterdataForecastsDeleteModal from './MasterdataForecastsDeleteModal'

export default {
  name: 'MasterdataForecasts',

  components: {
    MasterdataTableContainer
  },

  data() {
    return {
      components: {
        createModal: {
          component: MasterdataForecastsCreateModal,
          title: 'Skapa prognos'
        }
      },
      actions: [
        {
          title: 'Redigera',
          icon: 'mdi-pencil',
          component: MasterdataForecastsEditModal,
          type: 'edit'
        },
        {
          title: 'Ta bort',
          icon: 'mdi-delete',
          component: MasterdataForecastsDeleteModal,
          type: 'delete'
        }
      ],
      sortBy: 'updated',
      headers: [
        {
          text: 'Orsak',
          value: 'name'
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
          filterable: false,
          align: 'right'
        }
      ]
    }
  },

  apollo: {
    forecasts: {
      query: gql`
        query forecasts {
          forecasts {
            uuid
            created
            created_by
            updated
            updated_by
            name
          }
        }
      `
    }
  },

  methods: {
    refetch() {
      this.$apollo.queries.forecasts.refetch()
    }
  },

  computed: {
    tableData() {
      return this.forecasts || []
    }
  }
}
</script>
